import { RecordContextProvider, EditButton } from "react-admin";
import {
  List,
  Datagrid,
  TextField,
  TopToolbar,
  CreateButton,
  SimpleList,
} from "react-admin";
import { Typography, Stack, Box, useMediaQuery } from "@mui/material";
import { AssignTeamsButton } from "./AssignTeamsButton";
import { CopyTemplateButton } from "./CopyTemplateButton";

export function TrainingTemplateList() {
  const isSmall = useMediaQuery((theme: any) => theme.breakpoints.down("sm"));

  const ListActions = () => (
    <TopToolbar sx={{ mt: 0, pt: 0 }}>
      <CreateButton label="Neu" />
    </TopToolbar>
  );

  return (
    <Stack spacing={2} sx={{ p: 2, width: "100%" }}>
      <Typography variant="h5" fontWeight={800}>
        Trainings Editor
      </Typography>

      <List
        actions={<ListActions />}
        sort={{ field: "name", order: "ASC" }}
        sx={{
          "& .RaList-actions": { mt: 0, pt: 0, mb: 0 },
          "& .RaList-content": { pt: 0 },
          "& .MuiCardContent-root": { pt: 0 },
        }}
        exporter={false}
      >
        {isSmall ? (
          <SimpleList
            primaryText={(record) => record.name}
            secondaryText={() => ""} // optional: description etc.
            linkType={false}
            // Tertiary = unsere Actions sauber in einer Zeile
            tertiaryText={(record) => (
              <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mt: 1 }}>
                {/* RecordContext in SimpleList ist NICHT automatisch da,
                    daher geben wir record per ContextWrapper mit */}
                <Box sx={{ display: "flex", gap: 1 }}>
                  <EditButtonWithRecord record={record} />
                  <AssignTeamsButtonWithRecord record={record} />
                  <CopyTemplateButtonWithRecord record={record} />
                </Box>
              </Box>
            )}
          />
        ) : (
          <Datagrid rowClick={false} bulkActionButtons={false}>
            <TextField source="name" label="Spielname" />
            <EditButton label="" />
            <AssignTeamsButton />
            <CopyTemplateButton />
          </Datagrid>
        )}
      </List>
    </Stack>
  );
}

/**
 * SimpleList gibt KEIN RecordContext in tertiaryText,
 * deshalb wrappern wir die Buttons mit einem expliziten record prop.
 */
function AssignTeamsButtonWithRecord({ record }: { record: any }) {
  return (
    <Box sx={{ "& button": { minWidth: 0 } }}>
      {/* AssignTeamsButton nutzt useRecordContext -> wir geben RecordContext via Box nicht,
          daher nutzen wir "RecordContextProvider" aus react-admin */}
      {/* eslint-disable-next-line react/jsx-no-undef */}
      <RecordContextProvider value={record}>
        <AssignTeamsButton />
      </RecordContextProvider>
    </Box>
  );
}

function CopyTemplateButtonWithRecord({ record }: { record: any }) {
  return (
    <Box sx={{ "& button": { minWidth: 0 } }}>
      {/* eslint-disable-next-line react/jsx-no-undef */}
      <RecordContextProvider value={record}>
        <CopyTemplateButton />
      </RecordContextProvider>
    </Box>
  );
}

function EditButtonWithRecord({ record }: { record: any }) {
  return (
    <RecordContextProvider value={record}>
      <EditButton />
    </RecordContextProvider>
  );
}